import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";
import ClientViewDetails from "@/features/ventes/components/clients/ClientView";

export const Route = createFileRoute("/_app/ventes/clients/$id/view")({
  loader: requirePermission(PERMISSIONS.VENTES.CLIENTS.VIEW),
  staticData: {
    title: "Détails Client",
    icon: Users,
    showInBreadcrumb: true,
  },
  component: ClientViewDetails,
});
